import { render } from "./reset-password.vue?vue&type=template&id=09bc94bc&scoped=true&ts=true"
import script from "./reset-password.vue?vue&type=script&lang=ts"
export * from "./reset-password.vue?vue&type=script&lang=ts"

import "./reset-password.vue?vue&type=style&index=0&id=09bc94bc&scoped=true&lang=css"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bc94bc"]])

export default __exports__